"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentService = void 0;
class ContentService {
    constructor(baseURL, axios) {
        this.getCategories = () => __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.axios.get('categories', {
                baseURL: this.baseURL,
            });
            return data;
        });
        this.getTopWorksheet = () => __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.axios.get('worksheet/top', {
                baseURL: this.baseURL,
            });
            return data;
        });
        this.getWorksheets = (page_index, page_size = 10) => __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.axios.get(`/worksheet?page_index=${page_index}&page_size=${page_size}`, { baseURL: this.baseURL });
            return data;
        });
        this.getContent = (category, page_index, page_size = 10) => __awaiter(this, void 0, void 0, function* () {
            const searchParams = new URLSearchParams({
                category,
                page_index: page_index.toString(),
                page_size: page_size.toString(),
            });
            const { data } = yield this.axios.get(`content?${searchParams}`, {
                baseURL: this.baseURL,
            });
            return data;
        });
        this.getHighlights = () => __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.axios.get('home_page_highlights', {
                baseURL: this.baseURL,
            });
            return data;
        });
        this.getContentById = (id) => __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.axios.get(`content/${id}`, {
                baseURL: this.baseURL,
            });
            return data;
        });
        this.getMessagingCategories = () => __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.axios.get(`messaging/categories`, {
                baseURL: this.baseURL,
            });
            return data;
        });
        this.axios = axios;
        this.baseURL = baseURL;
    }
}
exports.ContentService = ContentService;
